import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Message.scss';

import { messagePrefix } from './Message';
import Icon from '../Icon/Icon';

export default class MessageItem extends Component {
  static propTypes = {
    content: PropTypes.string,
    type: PropTypes.string,
    duration: PropTypes.number,
    onClose: PropTypes.func,
    itemClass: PropTypes.string,
    itemStyle: PropTypes.object,
  };

  static defaultProps = {
    duration: 2000,
    onClose: () => undefined,
  };

  componentDidMount() {
    const { duration, onClose } = this.props;
    // 如果为0，则一直显示
    if (duration !== 0) {
      this.closeTimer = setTimeout(() => {
        onClose();
        this.clearCloseTimer();
      }, duration);
    }
  }

  componentWillUnmount() {
    this.clearCloseTimer();
  }

  clearCloseTimer = () => {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  };

  render() {
    // eslint-disable-next-line object-curly-newline
    const { itemClass, itemStyle, content, type } = this.props;
    const itemCls = classNames({
      [`${styles[`${messagePrefix}-item`]}`]: true,
    });
    const contentCls = classNames({
      [`${styles[`${messagePrefix}-content`]}`]: true,
      [`${styles[`${messagePrefix}-content-${type}`]}`]: true,
      [itemClass]: !!itemClass,
    });
    const iconName = ({
      info: 'info-circle',
      success: 'check-circle',
      error: 'times-circle',
      warning: 'exclamation-circle',
      loading: 'spinner',
    })[type];

    return (
      <div className={itemCls}>
        <div className={contentCls} style={itemStyle}>
          <Icon name={iconName} spin={type === 'loading'}/>
          <span>{content}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Message/MessageItem.js